module.exports = __webpack_public_path__ + "static/media/currencies-flag-sprite.5b49d209.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencies/currencies-flag-sprite.svg
// module id = 841
// module chunks = 7